<template>
  <b-form-input type="number" v-model="valueMutable" v-on:input="$emit('input', $event)"/>
</template>
<script>
import InputConfigMixin from '@/febos/global/empresas/componentes/configs/inputs/InputConfigMixin';

export default {
  name: 'ConfigInputText',
  mixins: [InputConfigMixin],
  data() {
    return {
      valueMutable: ''
    };
  },
  props: {
    value: {
      type: String,
      required: false,
    }
  },
  mounted() {
    this.valueMutable = this.value;
  }
};
</script>
